import './cart_component.scss'

export default () => ({})
